<template>
  <div class="code-snippet-container">
    <div class="code-snippet-header">
      <h3 class="code-snippet-title">Exemplo de Código</h3>
      <div class="language-selector">
        <label for="language-select">Linguagem:</label>
        <select 
          id="language-select"
          v-model="selectedLanguage"
          class="language-select"
        >
          <option value="javascript">JavaScript</option>
          <option value="python">Python</option>
          <option value="java">Java</option>
          <option value="csharp">C#</option>
          <option value="php">PHP</option>
          <option value="curl">cURL</option>
        </select>
      </div>
    </div>

    <div class="code-snippet-body">
      <div class="code-block">
        <pre><code>{{ generatedCode }}</code></pre>
      </div>
      <button 
        @click="copyCode"
        class="copy-button"
        :class="{ copied: copied }"
      >
        <svg v-if="!copied" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
        </svg>
        <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
        {{ copied ? 'Copiado!' : 'Copiar' }}
      </button>
    </div>

    <!-- Informações do endpoint -->
    <div v-if="endpoint" style="padding: 1rem 1.5rem; background-color: var(--lwsa-gray-50); border-top: 1px solid var(--lwsa-gray-200);">
      <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.75rem;">
        <span class="method-badge" :class="`method-${endpoint.method.toLowerCase()}`">
          {{ endpoint.method }}
        </span>
        <code class="endpoint-path">{{ endpoint.path }}</code>
      </div>
      <p style="font-size: 0.875rem; color: var(--lwsa-gray-600); margin: 0;">
        {{ endpoint.description || 'Endpoint da API' }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { generateCodeSnippet } from '@/services/codeGenerator'

const props = defineProps({
  api: {
    type: Object,
    required: true
  },
  endpoint: {
    type: Object,
    required: true
  }
})

const selectedLanguage = ref('javascript')
const copied = ref(false)

const generatedCode = computed(() => {
  return generateCodeSnippet(props.api, props.endpoint, selectedLanguage.value)
})

const copyCode = async () => {
  try {
    await navigator.clipboard.writeText(generatedCode.value)
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  } catch (error) {
    console.error('Erro ao copiar código:', error)
    // Fallback para browsers antigos
    const textArea = document.createElement('textarea')
    textArea.value = generatedCode.value
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  }
}

watch(selectedLanguage, () => {
  copied.value = false
})
</script>